import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet"
import { connect } from 'react-redux'
import axios from 'axios'
import Moment from 'moment'
const WebsiteInventory = (props) => {



	return (
		<>
			<Helmet>

				<title>Website Inventory</title>
				<meta
					name="description"
					content={ `Website Sales Dashboard` }
				/>
				<link rel="stylesheet" href="../assets/css/style.css" />
				<script src="../assets/js/script.js" />
			</Helmet>
			<div className="content">
				<h1>
					Not Applicable
				</h1>
			</div>
		</>
	)
}

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
	user: state.Auth.user,
})

export default connect(mapStateToProps, {})(WebsiteInventory)